import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  InputSignal,
  Output,
  Signal
} from '@angular/core';
import { SzButtonComponent } from '../../controls/sz-button';
import { SzIconComponent } from '../sz-icon';
import { SzPartnerCardVariant } from './sz-partner-card.types';

@Component({
  selector: 'sz-partner-card',
  templateUrl: './sz-partner-card.component.html',
  styleUrls: ['./sz-partner-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzButtonComponent, SzIconComponent]
})
export class SzPartnerCardComponent {
  readonly logoSrc: InputSignal<string> = input.required<string>();
  readonly logoAlt: InputSignal<string> = input<string>('');
  readonly label: InputSignal<string> = input<string>('');
  readonly headline: InputSignal<string> = input<string>('');
  readonly description: InputSignal<string> = input<string>('');
  readonly ctaLabel: InputSignal<string> = input<string>('');
  readonly ctaAria: InputSignal<string> = input<string>('');
  readonly dismissAria: InputSignal<string> = input<string>('');
  readonly accent: InputSignal<string> = input<string>('#2198d5');
  readonly variant: InputSignal<SzPartnerCardVariant> = input<SzPartnerCardVariant>('feed');
  readonly dismissible: InputSignal<boolean> = input<boolean>(false);
  readonly logoFull: InputSignal<boolean> = input<boolean>(false);
  readonly clickable: InputSignal<boolean> = input<boolean>(false);
  readonly linkCta: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly action: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly dismissed: EventEmitter<void> = new EventEmitter<void>();

  readonly isInline: Signal<boolean> = computed((): boolean => this.variant() === 'inline');

  onCardClick(): void {
    if (this.clickable()) {
      this.action.emit();
    }
  }

  // Gdy cała karta jest klikalna, klik w CTA obsługuje już klik karty (bąbelkowanie) -
  // nie emitujemy akcji drugi raz. Gdy karta nie jest klikalna, CTA emituje samo.
  onCtaClick(): void {
    if (!this.clickable()) {
      this.action.emit();
    }
  }
}
